import { Link } from "react-router-dom";
import { ASSETS, BRAND, NAV } from "@/lib/constants";

export default function Footer() {
  const half = Math.ceil(NAV.length / 2);
  const colA = NAV.slice(0, half);
  const colB = NAV.slice(half);

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-navy border-t border-slate-soft mt-10"
    >
      {/* Brand mark band — The Next Stage logo at the top of every footer */}
      <div className="border-b border-slate-soft">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col items-center text-center">
          <Link
            to="/"
            data-testid="footer-brand-link"
            className="inline-block transition-transform duration-300 hover:scale-[1.02]"
          >
            <img
              src={ASSETS.brandLogoLockup}
              alt="The Next Stage"
              className="h-28 sm:h-32 lg:h-36 w-auto object-contain"
              loading="lazy"
            />
          </Link>
          <p className="font-bebas text-muted-ink tracking-[0.32em] mt-6 text-xs uppercase">
            Take Your Public Speaking Journey To The Next Stage
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="font-bebas tracking-[0.22em] text-gold text-sm mb-4">
            — The Next Stage —
          </div>
          <p className="font-cormorant text-2xl lg:text-3xl text-soft-gray leading-snug max-w-md">
            A powerful message deserves more than a private dream. It deserves a
            stage.
          </p>
          <div className="mt-8 flex items-center gap-4">
            <img
              src={ASSETS.producerLogo}
              alt={BRAND.producer}
              data-testid="footer-producer-logo"
              className="h-14 w-auto opacity-95 shrink-0"
              loading="lazy"
            />
            <div className="text-xs font-manrope text-muted-ink leading-relaxed">
              <div className="font-bebas tracking-[0.22em] text-gold text-xs">
                Produced by
              </div>
              <div className="font-manrope text-soft-gray mt-1">
                {BRAND.producer}
              </div>
              <div className="font-manrope text-muted-ink mt-1">
                {BRAND.founderTitle}: {BRAND.founder}
              </div>
              <Link
                to="/media-group"
                data-testid="footer-media-group-link"
                className="inline-flex items-center gap-1.5 text-gold hover:text-gold-bright transition mt-2 font-bebas tracking-[0.18em] text-[11px] uppercase"
              >
                About TNS Media Group <span aria-hidden="true">→</span>
              </Link>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="label-bebas text-gold">Site</div>
          <ul className="flex flex-col gap-2 mt-3">
            {colA.map((n) => (
              <li key={n.path}>
                <Link
                  to={n.path}
                  data-testid={`footer-link-${n.label.toLowerCase()}`}
                  className="font-manrope text-soft-gray hover:text-gold transition text-sm"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="label-bebas text-gold">More</div>
          <ul className="flex flex-col gap-2 mt-3">
            {colB.map((n) => (
              <li key={n.path}>
                <Link
                  to={n.path}
                  className="font-manrope text-soft-gray hover:text-gold transition text-sm"
                >
                  {n.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/privacy"
                className="font-manrope text-muted-ink hover:text-gold transition text-sm"
              >
                Privacy
              </Link>
            </li>
            <li>
              <Link
                to="/terms"
                className="font-manrope text-muted-ink hover:text-gold transition text-sm"
              >
                Terms
              </Link>
            </li>
            <li>
              <Link
                to="/accessibility"
                className="font-manrope text-muted-ink hover:text-gold transition text-sm"
              >
                Accessibility
              </Link>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="label-bebas text-gold">Reach Us</div>
          <ul className="flex flex-col gap-2 mt-3 text-sm">
            <li>
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email-link"
                className="font-manrope text-soft-gray hover:text-gold transition break-all"
              >
                {BRAND.email}
              </a>
            </li>
            <li>
              <a
                href={`tel:${BRAND.phoneTel}`}
                data-testid="footer-phone-link"
                className="font-manrope text-soft-gray hover:text-gold transition"
              >
                {BRAND.phone}
              </a>
            </li>
            <li className="font-manrope text-muted-ink">{BRAND.city}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-soft">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-manrope text-muted-ink">
            © {new Date().getFullYear()} {BRAND.producer}. All rights reserved.
          </p>
          <p className="text-xs font-bebas tracking-[0.32em] text-muted-ink uppercase">
            Pilot Series · {BRAND.city}
          </p>
        </div>
      </div>
    </footer>
  );
}
